// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

// Tema scelto in precedenza (persistito in localStorage dal toggle in AuthLayout.vue),
// letto qui una sola volta all'avvio cosi' l'app parte gia' con il tema giusto.
const temaSalvato = localStorage.getItem('tema') === 'dark' ? 'dark' : 'light'

export default createVuetify({
  theme: {
    defaultTheme: temaSalvato,
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#380C3C',
          secondary: '#5C1A63',
          background: '#F2F2F5',
          surface: '#FFFFFF',
        }
      },
      dark: {
        dark: true,
        colors: {
          primary: '#A85CB0',
          secondary: '#7A3A82',
          background: '#121212',
          surface: '#1E1E1E',
        }
      }
    }
  }
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
})
